import { render, staticRenderFns } from "./CertificateInfoPricing.vue?vue&type=template&id=cc0bdeba&"
import script from "./CertificateInfoPricing.vue?vue&type=script&lang=js&"
export * from "./CertificateInfoPricing.vue?vue&type=script&lang=js&"
import style0 from "./CertificateInfoPricing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports